
import LineChart from "@rio-cloud/rio-uikit/LineChart";
import Line from "@rio-cloud/rio-uikit/Line";
import Spinner from "@rio-cloud/rio-uikit/Spinner";
import { OccurrenceStepEnum, OccurrenceStepLabelEnum } from "../../../../enums/occurrenceStep";
import { StepChart } from "./stepChart";
import { OccurrenceWithTimeSpent } from "../../../../models/occurrence";

type LineData = {
  date: string;
  qtd: number;
};

export interface QuantityChartProps {
  activeTab: string;
  setActiveTab: (activeTab: string | null) => void;
  contentWithTooltip: (value: number) => any;
  occurrencesByDays: { [key in OccurrenceStepEnum]: { daily: { date: string, occurrences: any[] }[], monthly: { date: string, occurrences: any[] }[] } };
  occurrencesBySteps: { [key in OccurrenceStepEnum]: OccurrenceWithTimeSpent[] };
  allOccurrencesBySteps: { [key in OccurrenceStepEnum]: OccurrenceWithTimeSpent[] };
  finalizedOccurrencesBySteps?: { [key in OccurrenceStepEnum]: OccurrenceWithTimeSpent[] };
  timePeriod: "daily" | "monthly";
  containerWidth: number;
  adjustDataWithMinHeight: (data: any[], minHeightPercentage: number) => any[];
  isResponsiveView: boolean;
  loading?: boolean;
  chartWidthMultiplier: number;
  defaultChartMinWidth: number;
  dynamicBarSize: number;
  LEFT_LABEL_PAD: number;
  showQuantityChart: boolean;
  setShowQuantityChart: (showQuantityChart: boolean) => void;
  setStepFilter: (stepFilter: OccurrenceStepEnum | null) => void;
  setChassisListFilterByStep: (chassisListFilterByStep: string[]) => void;
  occurrenceStepAvailable: string[];
  assetIds?: string[];
  selectedMetric: "average" | "quantity";
  setTimePeriod: (timePeriod: "daily" | "monthly") => void;
  finishedFilter: string[];
  divideByUniqueChassis?: boolean;
}

export const QuantityChart = (props: QuantityChartProps) => {
  const isFinalized = props.finishedFilter.length === 1 && props.finishedFilter.includes('true');

  const getStepData = (stepKey: OccurrenceStepEnum): OccurrenceWithTimeSpent[] =>
    isFinalized
      ? (props.finalizedOccurrencesBySteps?.[stepKey] ?? [])
      : (props.allOccurrencesBySteps[stepKey] ?? []);

  const getStepCount = (stepKey: OccurrenceStepEnum): number => {
    if (!isFinalized && [...new Set(props.assetIds ?? [])].length === 0) return 0;
    return new Set(getStepData(stepKey).map((unic) => unic.chassis)).size;
  };

  return (
    <>
      <span className="flex w-full justify-between text-size-16 font-semibold p-8">
        <div>
          Quantidade de veículo por etapa
        </div>
        <div
          className="cursor-pointer"
          onClick={() => props.setShowQuantityChart(!props.showQuantityChart)}
        >
          <span
            className={`rioglyph rioglyph-chevron-${props.showQuantityChart ? "up" : "down"
              }`}
          />
        </div>
      </span>

      {props.showQuantityChart &&
        (
          <div className="flex items-center overflow-x-auto flex-nowrap pb-2 mb-4 -mx-4 px-4 snap-x snap-mandatory gap-3">
            {props.occurrenceStepAvailable.map((stepEnum) => {
              const stepKey = OccurrenceStepEnum[stepEnum as keyof typeof OccurrenceStepEnum];
              const value = getStepCount(stepKey);
              return (
                <div
                  key={stepEnum}
                  onClick={() => {
                    if (props.activeTab === stepKey) {
                      props.setActiveTab(null);
                      props.setStepFilter(null);
                      props.setChassisListFilterByStep([]);
                    } else {
                      props.setActiveTab(stepKey);
                      props.setStepFilter(stepKey);
                      props.setChassisListFilterByStep(getStepData(stepKey).map(item => item.chassis));
                    }
                  }}
                  className={`
                      flex flex-col justify-center border-b-2 border-t-2 text-left transition bg-gray-100 h-[65px] px-4 snap-start
                      cursor-pointer 
                      ${props.isResponsiveView ? "flex-none min-w-[150px]" : "flex-1"}  
                      ${props.activeTab === stepKey ? "bg-white text-color-primary font-bold border-b-4 border-b-[#30B4C0]" : "hover:bg-gray-100 text-gray-500"}
                      ${stepEnum !== props.occurrenceStepAvailable[props.occurrenceStepAvailable.length - 1] ? "border-r-[1px]" : ""}
                    `}
                >
                  <div className="text-size-12 font-bold line-clamp-2 h-[25px]">
                    {OccurrenceStepLabelEnum[stepEnum as keyof typeof OccurrenceStepLabelEnum]}
                  </div>
                  <div className="font-bold text-size-16 truncate mt-2">
                    {props.contentWithTooltip(value)}
                  </div>
                </div>
              )
            })}
          </div>
        )}

      {/* {props.showQuantityChart && props.activeTab === '' && (
        <div className="w-full h-full overflow-x-auto px-8 py-4">
          <StepChart
            adjustDataWithMinHeight={props.adjustDataWithMinHeight}
            data={props.occurrencesBySteps}
            finalizedData={props.finalizedOccurrencesBySteps}
            chartWidthMultiplier={props.chartWidthMultiplier}
            defaultChartMinWidth={props.defaultChartMinWidth}
            dynamicBarSize={props.dynamicBarSize}
            isResponsiveView={props.isResponsiveView}
            loading={props.loading}
            metric="quantity"
          />
        </div>
      )} */}

    </>
  );
};
